export default {
  writeAssets(state, value) {
    state.assets = value
  },
  writeLiabilities(state, value) {
    state.liabilities = value
  }
}
